<template>
    <section>
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiBookOpenPageVariant }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Benefits & Services
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>

        <v-container class="d-flex justify-space-around align-center flex-wrap">
            <!-- 1st Col Content -->
            <div class="col-content">
                <!-- Important Reminders -->
                <ImportantReminders />
                <!-- End 1st Col Content -->
            </div>

            <!-- Benefits and Services -->
            <div class="b-s">
                <div class="services-wrapper">
                    <h2 class="my-5">
                        Services
                    </h2>

                    <div
                        class="services-content d-flex justify-space-around align-center flex-wrap"
                    >
                        <!-- In-patient -->
                        <InpatientServices />

                        <!-- Out-patient -->
                        <OutpatientServices />

                        <!-- Emergency -->
                        <EmergencyServices />

                        <!-- Dental -->
                        <DentalServices />

                        <!-- Preventive Healthcare -->
                        <PreventiveHealthcare />

                        <!-- Annual Check-up -->
                        <AnnualCheckup />
                    </div>
                </div>
                <!-- End of services wrapper -->

                <!-- <div class="my-12">
                    <h4 style="color:#1b5e20; word-break: break-word;">
                        IMPORTANT REMINDER:
                    </h4>
                    <v-divider />
                    <p>
                        All Hospital/Clinic/MSU charges that are NOT coverable by HMI must
                        be paid by the member upon discharge. Any outstanding or unpaid
                        obligations will lead to the lapsation of your membership and
                        prevent you from availing of the healthcare benefits of your HMI
                        Program.
                    </p>

                    <p>
                        For more information, kindly refer to the HMI Service Agreement
                    </p>
                </div> -->
                <!-- End Benefits and services Wrapper -->
            </div>
        </v-container>
        <router-view />
    </section>
</template>

<script>
import ImportantReminders from './BOSComp/ImportantReminders.vue'
import InpatientServices from './BOSComp/Services/InpatientServices.vue'
import OutpatientServices from './BOSComp/Services/OutpatientServices.vue'
import EmergencyServices from './BOSComp/Services/EmergencyServices.vue'
import DentalServices from './BOSComp/Services/DentalServices.vue'
import AnnualCheckup from './BOSComp/Services/AnnualCheckup.vue'
import PreventiveHealthcare from './BOSComp/Services/PreventiveHealthcare.vue'
import { mdiBookOpenPageVariant } from '@mdi/js'

export default {
    components: {
        ImportantReminders,
        InpatientServices,
        OutpatientServices,
        EmergencyServices,
        DentalServices,
        AnnualCheckup,
        PreventiveHealthcare
    },
    data: () => ({
        mdiBookOpenPageVariant
    })
}
</script>

<style scoped>
section {
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}

/* Main wrapper of content */
.col-content {
  width: 80%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
}

/* Benefits and Services */
.b-s {
  width: 90%;
  margin: 20px 0px;
}

/* Services */
.services-wrapper h2,
.benefits-wrapper h2 {
  color: gray;
  font-weight: normal;
  font-size: 20px;
}

.services-content {
  width: 100%;
}

/* Benefits */
.benefits-wrapper {
  height: 100%;
}

@media (max-width: 390px) {
  .page-icon {
    display: none;
  }
}

@media (max-width: 599px) {
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
  .col-content {
    width: 100%;
  }

  .benefits-wrapper h3 {
    text-align: center;
  }
}
@media (min-width: 599px) and (max-width: 968px) {
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }

  .benefits-wrapper h3 {
    text-align: center;
    font-size: 25px;
  }
}
@media (min-width: 968px) and (max-width: 1264px) {
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
  .services-content {
    width: 95%;
    margin: auto;
  }
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .services-content {
    width: 90%;
    margin: auto;
  }
}
</style>
